// extracted by mini-css-extract-plugin
export default {"preview":"BetaKeys_preview__PlKjm","keys":"BetaKeys_keys__7VtRK","code":"BetaKeys_code__Tk1ek"};